module.exports = __webpack_public_path__ + "img/purpose.5d6761df.svg";